module.exports = __webpack_public_path__ + "static/img/cc-logo_large_black.png";